import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthGate } from "./features/auth-pin/AuthGate";
import { PhotoPinGuard } from "./features/auth-pin/PhotoPinGuard";
import { BottomNav } from "./components/ui/BottomNav";
import { DashboardPage } from "./features/dashboard/DashboardPage";
import { SessionsPage } from "./features/sessions/SessionsPage";
import { MeasurementsPage } from "./features/measurements/MeasurementsPage";
import { PhotosPage } from "./features/photos/PhotosPage";

function AppShell() {
  return (
    <>
      <main className="px-3.5 pb-[100px] pt-3.5">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/entreno" element={<SessionsPage />} />
          <Route path="/medidas" element={<MeasurementsPage />} />
          <Route
            path="/fotos"
            element={
              <PhotoPinGuard>
                <PhotosPage />
              </PhotoPinGuard>
            }
          />
        </Routes>
      </main>
      <BottomNav />
    </>
  );
}

export function App() {
  return (
    <BrowserRouter>
      <AuthGate>
        <AppShell />
      </AuthGate>
    </BrowserRouter>
  );
}
